<template>
  <a
    v-if="visible"
    class="tooltip"
    :data-tooltip="
      showTooltip ? `VirusTotal: ${item.chocoPackage.PackageScanStatus}` : false
    "
    :href="`${item.chocoPackage.GalleryDetailsUrl}#virus`"
    target="_blank"
  >
    <slot></slot>
  </a>
</template>

<script>
import checks from "@/utils/packageCheck";

export default {
  props: { item: Object, showTooltip: Boolean },
  computed: {
    visible() {
      return checks.hasFailedVirusScan(this.item);
    }
  }
};
</script>
